<script setup lang="ts">
import { ref, toRefs } from 'vue'
import { useObjectAdd } from '../model/model'
import { VIcons, VModal } from '@/shared/ui'
import { ObjectTypes } from '@/entities/Object'

const { data, rules, close, show } = toRefs(useObjectAdd())

const valid = ref(true)
</script>

<template>
  <VModal v-model="show">
    <template #title><VIcons type="library_add" /> {{ $t('itf.add_object') }}</template>

    <VForm v-model="valid">
      <VTextField :label="$t('itf.name')" v-model="data.name" :rules="rules.name" />

      <VSelect
        :label="$t('itf.object_type')"
        :items="Object.values(ObjectTypes)"
        v-model="data.type"
      />

      <VTextarea rows="3" :label="$t('itf.description')" v-model="data.description" />

      <div class="form__btn_right">
        <VBtn color="default" variant="tonal" @click="close">{{ $t('itf.cancel') }}</VBtn>
        <VBtn type="submit">{{ $t('itf.add') }}</VBtn>
      </div>
    </VForm>
  </VModal>
</template>
